module.exports = __webpack_public_path__ + "img/1.dcbe91ef.jpg";